export default {
  namespaced: true,//开启命名空间
  state: {
    //搜索框
    searchShow: false,
    //骨架屏
    loadding: true,
    //多组勾选框
    groupBar: false,
    //多组选择列表页
    groupPage: false,
    //投票结束广告弹窗
    votePopAD: false,
    //微信二维码提示
    wxtipsShow: false,
    //微信公众号
    wxGzhTipsShow: false,
    //微信公众号提示文字
    wxGzhTips: '',
    //骨架框
    skeletonShow: true,
    //tabar
    tabarShow: true,
    //选手页关于广告关闭/开启状态
    floorAD: false,
    //图片旋转验证码
    imgRotateShow: false,
    imgRotateStatus: false,
    //输入型验证码
    vueVerify: false,
    vueVerifyStatus: false,
    //无边框广告
    noborderPop: false,
    //生成海报
    postShow: false,
  },
  mutations: {
    changeTFalse(state, val) {
      val.forEach((item, i) => {
        state[item.name] = item.value
      });
    }
  },
  actions: {

  },
  getters: {

  }
}
